var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64193 5.44047V2.9932H5.57246V3.57325M8.70361 2.21921C8.78693 2.13592 8.922 2.13592 9.00533 2.21921L16.1585 9.36921C16.4476 9.65821 16.243 10.1525 15.8342 10.1525H14.3572V16.9941C14.3572 17.053 14.3095 17.1008 14.2505 17.1008L10.3884 17.1007C10.3295 17.1007 10.2817 17.053 10.2817 16.994V14.0435C10.2817 13.69 9.99509 13.4033 9.64152 13.4033H7.93676C7.5832 13.4033 7.29657 13.69 7.29657 14.0435V16.9941C7.29657 17.053 7.2488 17.1008 7.18988 17.1008H3.44886C3.38994 17.1008 3.34217 17.053 3.34217 16.9941V10.1525H1.87476C1.46596 10.1525 1.26128 9.65821 1.55041 9.36921L8.70361 2.21921Z",
    stroke: "currentColor",
    strokeWidth: 0.711321,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeOutline);
export default __webpack_public_path__ + "static/media/home-outline.50d9614dc15acaa288de682af22dd755.svg";
export { ForwardRef as ReactComponent };